import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { env } from "@/env";

const appInsights = new ApplicationInsights({ config: { instrumentationKey: env.instrumentationKey } });

export class TelemetryService {
    public static startTrackPageView(name: string): void {
        appInsights.startTrackPage(name);
    }

    public static stopTrackPageView(name: string, url: string, properties?: IProperties, measurements?: IMeasurements): void {
        appInsights.stopTrackPage(name, url, properties, measurements);
    }

    public static logEvent(name: string, properties?: IProperties): void {
        appInsights.trackEvent({ name}, properties);
    }

    public static logError(error: Error | string, properties?: IProperties): void {
        appInsights.trackException(error as any, properties);
    }

    public static startTrackEvent(name: string): void {
        appInsights.startTrackEvent(name);
    }

    public static stopTrackEvent(name: string, properties?: IProperties, measurements?: IMeasurements): void {
        appInsights.stopTrackEvent(name, properties, measurements);
    }

    public static setAuthenticatedUserContext(userId: string): void {
        appInsights.setAuthenticatedUserContext(userId, userId);
    }
}

interface IProperties {
    [name: string]: string;
}

interface IMeasurements {
    [name: string]: number;
}
